module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid",
    attrs: {
      "id": "companies-index"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (item.types.includes('select')) ? _c('mdl-select', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "changeEvent": _vm.changed
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _vm._l((_vm.items[_vm.currentIndex].data), function(data, i) {
    return (!_vm.showProgress && _vm.items[_vm.currentIndex].types.includes('card')) ? _c('mdl-card', {
      key: data.id,
      attrs: {
        "i": i,
        "data": data,
        "index": _vm.currentIndex,
        "clickEvent": _vm.changed
      },
      on: {
        "showActionbar": function($event) {
          _vm.actionbar = $event
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.showProgress && _vm.items[_vm.currentIndex].types.includes('summary')) ? _c('mdl-summary', {
    attrs: {
      "tree": _vm.tree,
      "data": _vm.items[_vm.currentIndex].data,
      "childData": _vm.items[_vm.currentIndex + 1].data,
      "index": _vm.currentIndex,
      "clickEvent": _vm.changed
    },
    on: {
      "activeAudit": function($event) {
        _vm.activeAudit = $event
      },
      "saveTree": function($event) {
        _vm.$idb.keyVal.set('tree', undefined, $event)
      },
      "goBack": function($event) {
        _vm.currentIndex += $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showProgress && _vm.items[_vm.currentIndex].types.includes('audit')) ? _c('mdl-audit', {
    attrs: {
      "tree": _vm.tree,
      "data": _vm.items[_vm.currentIndex].data,
      "index": _vm.currentIndex
    },
    on: {
      "activeAudit": function($event) {
        _vm.activeAudit = $event
      },
      "goBack": function($event) {
        _vm.currentIndex += $event
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d86727d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Auditor/Audit/index.vue
// module id = 254
// module chunks = 0